import kebabCase from 'lodash/kebabCase';
import toString from 'lodash/toString';
// Import Actions
import {
    ADDING_USER_COMMENT,
    FETCHED_NEW_PHOTOGRAPHER_REVIEW,
    FETCHED_PHOTOGRAPHER_DATA,
    FETCHED_PHOTOGRAPHER_REVIEW_LIST,
    SET_REVIEW_MODAL_STATE,
    USER_HAS_PHOTGRAPHER_REVIEW,
    CLEAR_PHOTOGRAPHER_REVIEW_LIST,
    FETCH_SEARCH_PAGE_VENDOR_KEY,
    VENDORS_SET_FILTERS,
    VENDOR_IS_OPEN_GALLERY_FOR_SEARCHPAGE,
    VENDOR_UPDATING_VENUE_SEARCH_VALIDATORS,
    VENDORS_FETCHING_VENUES,
    LOAD_VENDOR_LIST,
    FETCH_VENDOR_SEARCH_PAGE_ALL_ASSET,
    VENDORS_SET_APPLIED_FILTERS,
    VENDORS_SET_MIN_MAX_FILTER_ITEM,
    VENDORS_SET_PAGE_FILTERS,
    SET_VENDOR_FILTER_ITEM,
    SET_VENDOR_FILTER,
    SET_SELECTED_VENDOR,
    SET_SORT_VENDOR_FILTERS,
    CLEAR_VENDOR_REVIEW_LIST,
    FETCHED_VENDOR_REVIEW_LIST,
    USER_HAS_VENDOR_REVIEW,
    SET_VENDOR_SUCCESS_MODAL_STATE,
} from '../actions/VendorActions';

// Initial State
const initialState = {
    isReviewModalVisible: false,
    photographer: {},
    photographerAssets: [],
    photographerReviews: [],
    photographerPackages: [],
    photographerFaqs: [],
    photographerExpertReviews: [],
    photographerReviewList: [],
    photographerReviewCount: null,
    userHasPhotographerReview: false,
    userHasVendorReview: false,
    userPhotographerReview: {},
    userVendorReview: {},
    vendorTypeNeeded: null,
    vendorEventBtnSource: '',
    clickedVenueAssets: {},
    isOpenGalleryForSearchPage: false,
    updateQnaPage: false,
    isFetchingVenueAssets: false,
    isBaseFiltersLoaded: false,
    isLocationFiltersLoaded: false,
    vendorSearchFilters: [],
    sortFilters: [],
    vendorSearchParams: [],
    appliedFilters: {},
    isFetchingVenues: false,
    list: [],
    clickedVendor: {},
    selectedVenue: {},
    vendorReviewList: [],
    vendorReviewCount: null,
    vendorReviews: [],
    isSuccessModalVisible:false
};

const VenueReducers = (state = initialState, action) => {
    let clickedVenueAssets = {};
    switch (action.type) {
        case FETCHED_PHOTOGRAPHER_DATA:
            return {
                ...state,
                photographer: action.photographer,
                photographerAssets: action.assets,
                photographerReviews: action.reviews,
                photographerPackages: action.packages,
                photographerFaqs: action.faqs,
                photographerExpertReviews: action.expertReviews,
            };

        case SET_VENDOR_SUCCESS_MODAL_STATE:
            return {
                ...state,
                isSuccessModalVisible: action.isSuccessModalVisible,
            };

        case SET_REVIEW_MODAL_STATE:
            return {
                ...state,
                isReviewModalVisible: action.isReviewModalVisible,
            };

        case ADDING_USER_COMMENT:
            return {
                ...state,
                isAddingUserComment: action.isAddingUserComent,
            };

        case FETCHED_NEW_PHOTOGRAPHER_REVIEW:
            // state.photographerReviews.unshift(action.newPhotographReview)
            return {
                ...state,
                photographerReviews: state.photographerReviews,
            };

        case FETCHED_PHOTOGRAPHER_REVIEW_LIST:
            let fetchedReviews = [
                ...state.photographerReviewList,
                ...action.photographerReviewList,
            ];
            return {
                ...state,
                photographerReviewList: fetchedReviews,
                photographerReviewCount: action.photographerReviewCount,
            };

        case FETCHED_VENDOR_REVIEW_LIST:
            let vendorReviews = [...state.vendorReviewList, ...action.vendorReviewList];
            return {
                ...state,
                vendorReviewList: vendorReviews,
                vendorReviewCount: action.vendorReviewCount,
            };

        case USER_HAS_PHOTGRAPHER_REVIEW:
            return {
                ...state,
                userPhotographerReview: action.userPhotographerReview,
                userHasPhotographerReview: action.userHasPhotographerReview,
            };
        case USER_HAS_VENDOR_REVIEW:
            return {
                ...state,
                userVendorReview: action.userVendorReview,
                userHasVendorReview: action.userHasVendorReview,
            };

        case CLEAR_PHOTOGRAPHER_REVIEW_LIST:
            return {
                ...state,
                photographerReviewList: action.payload,
            };
        case CLEAR_VENDOR_REVIEW_LIST:
            return {
                ...state,
                vendorReviewList: action.payload,
            };
        case FETCH_SEARCH_PAGE_VENDOR_KEY:
            let vendorObj = {};
            if (action.searchPageVendorKey === 'p') {
                vendorObj.isPhotographerNeeded = true;
            } else if (action.searchPageVendorKey === 'd') {
                vendorObj.isDecoratorNeeded = true;
            }
            return {
                ...state,
                vendorTypeNeeded: vendorObj,
                vendorEventBtnSource: action.vendorEventBtnSource,
                searchPageVendorKey: action.searchPageVendorKey,
            };
        case VENDORS_SET_FILTERS: //needed
            return {
                ...state,
                vendorSearchFilters: action.vendorSearchFilters,
                sortFilters: action.sortFilters,
                isBaseFiltersLoaded: action.isBaseFiltersLoaded,
                vendorSearchParams: action.vendorSearchParams,
            };

        case VENDOR_IS_OPEN_GALLERY_FOR_SEARCHPAGE: //needed
            clickedVenueAssets = { ...state.clickedVenueAssets };
            if (action.vendor && action.vendor._id) {
                if (clickedVenueAssets[action.vendor._id]) {
                    clickedVenueAssets[action.vendor._id].vendor = action.vendor;
                } else {
                    clickedVenueAssets[action.vendor._id] = {};
                    clickedVenueAssets[action.vendor._id].vendor = action.vendor;
                }
            }
            return {
                ...state,
                isVenueGalleryOpen: action.isVenueGalleryOpen,
                isFetchingVenueAssets: action.isFetchingVenueAssets,
                clickedVenueAssets: clickedVenueAssets,
                clickedVendor: action.vendor,
            };
        case VENDOR_UPDATING_VENUE_SEARCH_VALIDATORS: //needed
            return {
                ...state,
                isUpdatingVenueSearchValidators: action.isUpdatingVenueSearchValidators,
            };
        case VENDORS_FETCHING_VENUES: //needed
            return {
                ...state,
                isFetchingVenues: action.isFetchingVenues,
            };
        case LOAD_VENDOR_LIST: //needed
            return {
                ...state,
                list: action.list,
                totalCount: action.totalCount,
                isFetchingVenues: action.isFetchingVenues,
                pageNum: action.pageNum,
                searchlink: action.searchlink,
                searchValidators: action.searchValidators,
            };
        case FETCH_VENDOR_SEARCH_PAGE_ALL_ASSET: //needed
            clickedVenueAssets = { ...state.clickedVenueAssets };
            if (action.vendor_id) {
                if (clickedVenueAssets[action.vendor_id]) {
                    clickedVenueAssets[action.vendor_id].images = action.images;
                    clickedVenueAssets[action.vendor_id].assets = action.assets;
                } else {
                    clickedVenueAssets[action.vendor_id] = {};
                    clickedVenueAssets[action.vendor_id].images = action.images;
                    clickedVenueAssets[action.vendor_id].assets = action.assets;
                }
            }
            return {
                ...state,
                isFetchingVenueAssets: false,
                clickedVenueAssets: clickedVenueAssets,
            };

        case VENDORS_SET_APPLIED_FILTERS: //needed
            return {
                ...state,
                appliedFilters: action.appliedFilters,
            };
        case VENDORS_SET_MIN_MAX_FILTER_ITEM: //needed
            let vendorMinMaxFilter = [...state.vendorSearchFilters].map((filterItem) => {
                if (filterItem.minQueryParamName === action.paramName) {
                    filterItem.minParams = filterItem?.minParams?.map((item) => {
                        item.isSelected = toString(item.value) === toString(action.value);
                        return item;
                    });
                } else if (filterItem.maxQueryParamName === action.paramName) {
                    filterItem.maxParams = filterItem?.maxParams?.map((item) => {
                        item.isSelected = toString(item.value) === toString(action.value);
                        return item;
                    });
                }
                return filterItem;
            });
            return {
                ...state,
                vendorSearchFilters: vendorMinMaxFilter,
            };

        case VENDORS_SET_PAGE_FILTERS: //needed
            return {
                ...state,
                vendorSearchFilters: action.vendorSearchFilters,
            };

        case SET_VENDOR_FILTER_ITEM: //needed
            let venueFilters = state.vendorSearchFilters.map((filterItem) => {
                if (filterItem.queryParamName === action.paramName) {
                    filterItem.params = filterItem.params.map((item) => {
                        item.isSelected = kebabCase(item.value) === kebabCase(action.value);
                        return item;
                    });
                }
                return filterItem;
            });
            return {
                ...state,
                vendorSearchFilters: venueFilters,
            };

        case SET_VENDOR_FILTER: //needed
            let filters = state.vendorSearchFilters.map((filterItem) => {
                if (filterItem.queryParamName === action.paramName) {
                    filterItem.params = filterItem.params.map((item) => {
                        if (toString(item.value) === toString(action.value)) {
                            item.isSelected = action.isSelected;
                        }
                        return item;
                    });
                }
                return filterItem;
            });
            return {
                ...state,
                vendorSearchFilters: filters,
            };

        case SET_SELECTED_VENDOR: //needed
            return {
                ...state,
                selectedVenue: action.selectedVenue,
            };

        case SET_SORT_VENDOR_FILTERS: //needed
            return {
                ...state,
                sortFilters: action.sortFilters,
            };

        default:
            return state;
    }
};

// Export Reducer
export default VenueReducers;
